@if (platformBrowser) {
  <app-not-found bgChars="503" errorTitle="Maintenance">
    @if (maintenanceService.getMaintenance(true) | async; as outage) {
      <p>
        {{ outage.duringOutageText | replace : '{{endTime}}' : (outage.toDate | date : 'shortTime') | replace : '{{
          startTime
        }}' : (outage.fromDate | date : 'shortTime') }}
      </p>
    } @else {
      <p>We are doing some unplanned maintenance and will be back soon.</p>
    }
    <br />
    <p class="legal">Note: This page will refresh automatically when we are back.</p>
  </app-not-found>
}
